import styles from './Users.module.scss'

const HotelsTooltip = ({ hotelsArray }) => (
  <div className={styles.tooltip}>
    {hotelsArray.map(h => (
      <p key={h}>{h.subsidiaryName}</p>
    ))}
  </div>
)

export default HotelsTooltip
